/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { UserEventSchema } from '../models/UserEventSchema';
import type { UserResourceSchema } from '../models/UserResourceSchema';
import type { VisitStatus } from '../models/VisitStatus';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CalendarUsersApi {
    /**
     * Get User Event List
     * Get user event list for users.<br>Required permission: get_user_event_list
     * @returns UserEventSchema OK
     * @throws ApiError
     */
    public static calendarGetUserEventListGet({
        start,
        end,
        userIds,
        statuses,
    }: {
        /**
         * When to start filtering.
         */
        start: string,
        /**
         * When to end filtering.
         */
        end: string,
        /**
         * A list of user ids.
         */
        userIds: Array<string>,
        /**
         * Only return visits in these statuses. Omit for all statuses.
         */
        statuses?: (Array<VisitStatus> | null),
    }): CancelablePromise<Array<UserEventSchema>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/calendar-users/events/',
            query: {
                'start': start,
                'end': end,
                'statuses': statuses,
                'user_ids': userIds,
            },
        });
    }
    /**
     * Get User Resource List
     * Get user company resources.<br>Required permission: get_resource_list
     * @returns UserResourceSchema OK
     * @throws ApiError
     */
    public static calendarGetUserResourceListGet(): CancelablePromise<Array<UserResourceSchema>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/calendar-users/resources/',
        });
    }
}
